import { IconProps } from "../../../types/style";

const RankingIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M8.67 14H4C2.9 14 2 14.9 2 16V22H8.67V14Z"
          fill={color}
        />
        <path
          d="M13.3299 10H10.6599C9.55991 10 8.65991 10.9 8.65991 12V22H15.3299V12C15.3299 10.9 14.4399 10 13.3299 10Z"
          fill={color}
        />
        <path
          opacity="0.4"
          d="M20.0001 17H15.3301V22H22.0001V19C22.0001 17.9 21.1001 17 20.0001 17Z"
          fill={color}
        />
        <path
          d="M15.0099 4.84999C15.3199 4.53999 15.4399 4.16999 15.3399 3.84999C15.2399 3.52999 14.9299 3.3 14.4899 3.23L13.5299 3.06999C13.4899 3.05999 13.3999 2.99998 13.3799 2.95998L12.8499 1.89998C12.4499 1.08998 11.5399 1.08998 11.1399 1.89998L10.6099 2.95998C10.5899 2.99998 10.4999 3.05999 10.4599 3.06999L9.49993 3.23C9.05993 3.3 8.75993 3.52999 8.64993 3.84999C8.54993 4.16999 8.66993 4.53999 8.97993 4.84999L9.71993 5.59999C9.74993 5.62999 9.78993 5.75 9.77993 5.79L9.56993 6.70998C9.40993 7.38998 9.66993 7.69997 9.83993 7.82997C10.0099 7.94997 10.3799 8.10999 10.9899 7.74999L11.8899 7.21999C11.9299 7.18999 12.0599 7.18999 12.0999 7.21999L12.9999 7.74999C13.2799 7.91999 13.5099 7.96999 13.6899 7.96999C13.8999 7.96999 14.0499 7.88997 14.1399 7.82997C14.3099 7.70997 14.5699 7.39998 14.4099 6.70998L14.1999 5.79C14.1899 5.74 14.2199 5.62999 14.2599 5.59999L15.0099 4.84999Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default RankingIcon;
